<template>
    <div>

        <v-alert v-if="!grid || !grid.id" type="info" text dense class="ma-4">
            Salve a disciplina da turma para cadastrar horários fixos.
        </v-alert>

        <v-card v-else elevation="0">

            <v-card-text>
                <v-row dense align="center">
                    <v-col cols="12" sm="4">
                        <sys-select-day-of-week
                            :model.sync="form.day_of_week_id"
                            :errors="errors.day_of_week_id"
                            :error="!!errors.day_of_week_id"
                            label="Dia da semana*"
                            dense
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-select
                            v-model="form.hour_id"
                            :items="hours"
                            item-value="id"
                            item-text="name"
                            label="Horário (opcional)"
                            :error-messages="errors.hour_id"
                            clearable
                            dense
                            no-data-text="Nenhum horário cadastrado"
                        />
                    </v-col>
                    <v-col cols="12" sm="4" class="d-flex">
                        <v-btn color="primary" small class="mr-2" :loading="saving" :disabled="!form.day_of_week_id" @click.prevent.stop="save()">
                            {{ form.id ? 'Salvar' : 'Adicionar' }}
                            <v-icon right small>{{ form.id ? 'mdi-content-save' : 'mdi-plus' }}</v-icon>
                        </v-btn>
                        <v-btn v-if="form.id" small text @click.prevent.stop="resetForm()">Cancelar</v-btn>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-simple-table dense>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">Dia da semana</th>
                            <th class="text-left">Horário</th>
                            <th class="text-left">Situação</th>
                            <th class="text-center">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in items" :key="item.id">
                            <td>{{ dayName(item.day_of_week_id) }}</td>
                            <td>{{ hourName(item.hour_id) }}</td>
                            <td>
                                <v-chip v-if="isBlocked(item)" x-small color="orange" dark>
                                    <v-icon x-small left>mdi-lock</v-icon>
                                    Bloqueado
                                </v-chip>
                                <span v-else>-</span>
                            </td>
                            <td class="text-center">
                                <v-tooltip v-if="isBlocked(item)" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon v-bind="attrs" v-on="on" small color="grey">mdi-lock-outline</v-icon>
                                    </template>
                                    <span>Horário bloqueado, não pode ser alterado ou excluído. O registro foi incluído dinamicamente por outro processo</span>
                                </v-tooltip>
                                <template v-else>
                                    <v-btn icon x-small @click.prevent.stop="edit(item)"><v-icon small color="purple">mdi-pencil</v-icon></v-btn>
                                    <v-btn icon x-small @click.prevent.stop="confirmDelete(item)"><v-icon small color="red">mdi-delete</v-icon></v-btn>
                                </template>
                            </td>
                        </tr>
                        <tr v-if="!items.length">
                            <td colspan="4" class="text-center grey--text">
                                {{ loading ? 'Carregando...' : 'Nenhum horário fixo cadastrado para esta disciplina.' }}
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <emc-alert-modal text="Deseja excluir este horário fixo?" :disabled="deleting" v-bind:show.sync="showDelete">
                <template v-slot:actions>
                    <v-btn color="error" @click.prevent.stop="destroy()" :loading="deleting" :disabled="deleting">Excluir <v-icon right dark>mdi-delete</v-icon></v-btn>
                </template>
            </emc-alert-modal>

            <emc-alert-snackbar :show="!! message.length" :message="message" :color="error ? 'error' : 'success'"/>

        </v-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: "SysGridTimeTableFixed",
    props: {
        grid: {
            type: Object,
            default: () => ({})
        }
    },
    data: () => ({
        items: [],
        hours: [],
        days: {
            1: 'Domingo', 2: 'Segunda-Feira', 3: 'Terça-Feira', 4: 'Quarta-Feira',
            5: 'Quinta-Feira', 6: 'Sexta-Feira', 7: 'Sábado'
        },
        form: { id: null, day_of_week_id: null, hour_id: null },
        errors: {},
        message: '',
        error: false,
        loading: false,
        saving: false,
        deleting: false,
        showDelete: false,
        itemDelete: null,
    }),
    created() {
        this.loadHours();
        this.loadItems();
    },
    watch: {
        'grid.id'() {
            this.resetForm();
            this.loadItems();
        },
    },
    methods: {
        ...mapActions('hour', ['ActionGetHours']),
        ...mapActions('grid', [
            'ActionFindGridTimeTableFixeds',
            'ActionStoreGridTimeTableFixed',
            'ActionUpdateGridTimeTableFixed',
            'ActionDestroyGridTimeTableFixed',
        ]),

        isBlocked(item) {
            return item.blocked == 1;
        },

        dayName(id) {
            return this.days[id] || '-';
        },

        hourName(id) {
            if (!id) return 'Dia todo';

            const hour = this.hours.find(h => h.id == id);

            return hour ? hour.name : id;
        },

        loadHours() {
            this.ActionGetHours().then((res) => {
                this.hours = res.data;
            });
        },

        loadItems() {
            if (!this.grid || !this.grid.id) {
                this.items = [];
                return;
            }

            this.loading = true;

            this.ActionFindGridTimeTableFixeds({
                find_columns: { grid_id: this.grid.id },
                per_page: 200,
                column_order: 'day_of_week_id',
                direction: 'asc',
            })
                .then((res) => {
                    this.items = res.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        resetForm() {
            this.form = { id: null, day_of_week_id: null, hour_id: null };
            this.errors = {};
        },

        edit(item) {
            if (this.isBlocked(item)) return;

            this.errors = {};
            this.form = { id: item.id, day_of_week_id: item.day_of_week_id, hour_id: item.hour_id };
        },

        save() {
            this.message = '';
            this.error = false;
            this.errors = {};
            this.saving = true;

            const payload = { day_of_week_id: this.form.day_of_week_id, hour_id: this.form.hour_id || null };

            const request = this.form.id
                ? this.ActionUpdateGridTimeTableFixed({ id: this.form.id, ...payload })
                : this.ActionStoreGridTimeTableFixed({
                    ...payload,
                    grid_id: this.grid.id,
                    work_time_id: this.grid.work_time_id,
                });

            request
                .then((res) => {
                    this.message = res.message;
                    this.resetForm();
                    this.loadItems();
                })
                .catch((error) => {
                    this.error = true;
                    this.errors = error.errors || {};
                    this.message = error.message;
                })
                .finally(() => {
                    this.saving = false;
                });
        },

        confirmDelete(item) {
            if (this.isBlocked(item)) return;

            this.itemDelete = item;
            this.showDelete = true;
        },

        destroy() {
            this.deleting = true;
            this.message = '';
            this.error = false;

            this.ActionDestroyGridTimeTableFixed({ id: this.itemDelete.id })
                .then((res) => {
                    this.message = res.message;
                    this.loadItems();
                })
                .catch((error) => {
                    this.error = true;
                    this.message = error.message;
                })
                .finally(() => {
                    this.deleting = false;
                    this.showDelete = false;
                    this.itemDelete = null;
                });
        },
    }
}
</script>
